import React, { useState, useEffect } from "react";
import ReactECharts from "echarts-for-react";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import { FaChartBar, FaChartLine, FaChartPie } from "react-icons/fa";
import { useTheme } from "../../Themecontext/Themecontext";
const FASChart = ({
  data = [],
  labelKey = "month",
  valueKey = "value",
  labelMap = {},
}) => {
  // ================= MOBILE =================

  const { theme } = useTheme();
  const isdark = theme;

  const { Colourdata } = useSelector((state) => state.ClientLogin);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");

  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const [isMobile, setIsMobile] = useState(window.innerWidth < 576);

  const getLabelInterval = () => {
    const totalLabels = chartLabels?.length || 0;

    // desktop pe sab dikhao
    if (!isMobile) return 0;

    // mobile responsive logic
    if (totalLabels > 25) {
      return (index) => index % 3 !== 0; // 1 show, 2 skip
    }

    if (totalLabels > 12) {
      return (index) => index % 2 !== 0; // alternate
    }

    return 0; // sab show
  };
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 576);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // ================= CHART TYPE =================
  const [chartType, setChartType] = useState("bar");

  // ================= DATA =================
  // ================= HIDE COLUMNS =================
  const hiddenColumns = [
    "srNumber",
    "Id",
    "id",
    "AcID",
    "Total",
    "ItemID",
    "Meter",
    "cumulativeBalance",
    "chart",
    "Balance",
    "TotalAmount",
    "FinishMeter",
    "NetAmount",
    "Rate",
    "HighRate",
    "LowRate",
    "FirmID",
    "AcYearID",
    "BookID",
    "pcs",
    "Price",
    "VouDate",
    "Amount",
    "Qty",
    "TaxAmt",
    "ItemName"
  ];

  // ================= DATA =================
  const chartData = Array.isArray(data)
    ? data
      .filter((item) => {
        const columnName = item?.[labelKey];
        return !hiddenColumns.includes(columnName);
      })
      .map((item) => ({
        label: labelMap[item?.[labelKey]] || item?.[labelKey] || "N/A",
        value: Number(item?.[valueKey] || 0),
      }))
    : Object.entries(data || {})
      .filter(([key, value]) => {
        return !hiddenColumns.includes(key) && !isNaN(Number(value));
      })
      .map(([key, value]) => ({
        label: labelMap[key] || key,
        value: Number(value),
      }));
  const chartLabels = chartData.map((item) => item.label);

  const chartValues = chartData.map((item) => item.value);

  const hasChartData =
    chartValues &&
    chartValues.length > 0 &&
    chartValues.some((val) => Number(val) > 0);

  // ================= LINE OPTION =================
  const lineOption = {
    tooltip: {
      trigger: "axis",
      confine: true,
    },

    grid: {
      left: "5%",
      right: "5%",
      top: "15%",
      bottom: isMobile ? "30%" : "12%",
      containLabel: true,
    },

    xAxis: {
      type: "category",
      boundaryGap: false,
      data: chartLabels,

      axisLabel: {
        interval: isMobile && chartLabels?.length > 20 ? 1 : 0,
        color: isdark === "light" ? "#000" : "#fff",
        rotate: isMobile ? 60 : 45,
        fontSize: isMobile ? 9 : 12,
        margin: 14,
        hideOverlap: true,

        formatter: (value) => {
          if (!value) return "N/A";

          return String(value).length > 10
            ? String(value).slice(0, 10) + "..."
            : value;
        },
      },
    },

    yAxis: {
      type: "value",

      axisLabel: {
        fontSize: isMobile ? 10 : 12,
        color: isdark === "light" ? "#000" : "#fff",
      },

      splitLine: {
        show: true,

        lineStyle: {
          color:
            isdark === "light" ? iscolour?.Colour11 : iscolourDark?.Colour8,
          type: "solid",
          width: 1,
        },
      },
    },

    series: [
      {
        type: "line",
        smooth: true,
        data: chartValues,

        lineStyle: {
          width: isMobile ? 2 : 4,
          color:
            isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour9,
        },

        itemStyle: {
          color:
            isdark === "light" ? iscolour?.Colour10 : iscolourDark?.Colour9,

          borderColor:
            isdark === "light" ? iscolour?.Colour10 : iscolourDark?.Colour9,
        },

        emphasis: {
          disabled: true,
        },

        areaStyle: {
          color: {
            type: "linear",

            x: 0,
            y: 0,
            x2: 0,
            y2: 1,

            colorStops: [
              {
                offset: 0,
                color:
                  (isdark === "light"
                    ? iscolour?.Colour12
                    : iscolourDark?.Colour10) + "CC", // strong top
              },

              {
                offset: 0.5,
                color:
                  (isdark === "light"
                    ? iscolour?.Colour12
                    : iscolourDark?.Colour10) + "66", // middle fade
              },

              {
                offset: 1,
                color:
                  (isdark === "light"
                    ? iscolour?.Colour12
                    : iscolourDark?.Colour10) + "05", // transparent bottom
              },
            ],
          },
        },
      },
    ],
  };

  const barOption = {
    tooltip: {
      trigger: "axis",
      confine: true,

      textStyle: {
        fontSize: isMobile ? 10 : 12,
      },

      padding: isMobile ? 6 : 10,
    },

    grid: {
      left: "5%",
      right: "5%",
      top: "15%",
      bottom: isMobile ? "30%" : "12%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      data: chartLabels || [],

      boundaryGap: true,

      axisTick: {
        alignWithLabel: true,
      },

      splitLine: {
        show: false,
      },

      axisLabel: {
        interval: getLabelInterval(),
        color: isdark === "light" ? "#000" : "#fff",

        rotate: isMobile ? 60 : 45,
        fontSize: isMobile ? 9 : 12,
        margin: 14,

        hideOverlap: true,
        overflow: "truncate",
        width: isMobile ? 50 : 80,

        formatter: (value) => {
          if (!value) return "N/A";

          return String(value).length > 10
            ? String(value).slice(0, 10) + "..."
            : value;
        },
      },
    },

    yAxis: {
      type: "value",

      axisLabel: {
        fontSize: isMobile ? 10 : 12,
        color: isdark === "light" ? "#000" : "#fff",
      },

      splitLine: {
        show: true,
        lineStyle: {
          color:
            isdark === "light" ? iscolour?.Colour11 : iscolourDark?.Colour8,
          type: "solid",
          width: 1,
        },
      },
    },

    series: [
      {
        type: "bar",

        data: chartValues || [],

        barWidth: isMobile ? "65%" : "50%",

        itemStyle: {
          borderRadius: [8, 8, 0, 0],

          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,

            colorStops: [
              {
                offset: 0,
                color:
                  isdark === "light"
                    ? iscolour?.Colour12
                    : iscolourDark?.Colour10,
              },
            ],
          },
        },
      },
    ],
  };
  // ================= PIE OPTION =================
  const pieOption = {
    tooltip: {
      trigger: "item",
      confine: true,

      textStyle: {
        fontSize: isMobile ? 10 : 12,
      },

      padding: isMobile ? 6 : 10,
      borderWidth: 0,
    },

    legend: {
      top: isMobile ? "78%" : "85%",

      itemWidth: isMobile ? 10 : 18,
      itemHeight: isMobile ? 10 : 18,

      textStyle: {
        fontSize: isMobile ? 8 : 12,
        color: isdark === "light" ? "#000" : "#fff",
      },
    },

    series: [
      {
        name: "Share",
        type: "pie",

        top: isMobile ? 10 : 20,
        bottom: isMobile ? 20 : 40,

        radius: isMobile ? ["40%", "60%"] : ["50%", "75%"],

        center: isMobile ? ["50%", "36%"] : ["50%", "42%"],

        avoidLabelOverlap: true,

        data: chartData.slice(0, 12).map((item) => ({
          name: item.label,
          value: item.value,
        })),
        label: {
          show: !isMobile,
          position: "outside",
          formatter: "{b}: {d}%",
          fontSize: 12,
          color: isdark === "light" ? "#000" : "#fff",
        },

        labelLine: {
          show: !isMobile,
          length: isMobile ? 8 : 15,
          length2: isMobile ? 5 : 10,
          lineStyle: {
            width: 2,
            color: isdark === "light" ? "#000" : "#fff",
          },
        },

        color: [
          isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour1,

          isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour2,

          isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour3,

          isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour4,

          isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour5,

          isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour6,

          isdark === "light" ? iscolour?.Colour7 : iscolourDark?.Colour7,

          isdark === "light" ? iscolour?.Colour8 : iscolourDark?.Colour8,

          isdark === "light" ? iscolour?.Colour9 : iscolourDark?.Colour9,

          isdark === "light" ? iscolour?.Colour10 : iscolourDark?.Colour10,

          isdark === "light" ? iscolour?.Colour11 : iscolourDark?.Colour11,

          isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour12,
        ],

        itemStyle: {
          borderColor: "#fff",
          borderWidth: 2,
          borderRadius: 8,
        },

        emphasis: {
          scale: true,

          itemStyle: {
            shadowBlur: 10,
            shadowColor: "rgba(0,0,0,0.25)",
          },
        },
      },
    ],
  };

  // ================= GET OPTION =================
  const getOption = () => {
    switch (chartType) {
      case "line":
        return lineOption;

      case "pie":
        return pieOption;

      case "bar":
        return barOption;

      default:
        return barOption;
    }
  };

  return (
    <div
      style={{
        width: "100%",
        background:
          isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour3,

        padding: isMobile ? "10px" : "20px",
      }}
    >
      {/* BUTTONS */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
          flexWrap: "wrap",
        }}
      >
        <button
          onClick={() => setChartType("bar")}
          title="Bar Chart"
          className="hover-scale-btn"
          style={{
            width: isMobile ? "30px" : "40px",
            height: isMobile ? "30px" : "40px",
            borderRadius: "12px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "0.3s",
            backgroundColor:
              chartType === "bar"
                ? isdark === "light"
                  ? iscolour?.Colour12
                  : iscolourDark?.Colour8
                : "transparent",
            color:
              chartType === "bar"
                ? isdark === "light"
                  ? iscolour?.Colour1
                  : "#fff"
                : isdark === "light"
                  ? iscolour?.Colour12
                  : iscolourDark?.Colour8,
            border: `2px solid ${isdark === "light"
              ? iscolour?.Colour12
              : iscolourDark?.Colour8
              }`,
          }}
        >
          <FaChartBar size={isMobile ? 16 : 20} />
        </button>

        <button
          onClick={() => setChartType("line")}
          title="Line Chart"
          className="hover-scale-btn"
          style={{
            width: isMobile ? "30px" : "40px",
            height: isMobile ? "30px" : "40px",
            borderRadius: "12px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "0.3s",
            backgroundColor:
              chartType === "line"
                ? isdark === "light"
                  ? iscolour?.Colour12
                  : iscolourDark?.Colour8
                : "transparent",
            color:
              chartType === "line"
                ? isdark === "light"
                  ? iscolour?.Colour1
                  : "#fff"
                : isdark === "light"
                  ? iscolour?.Colour12
                  : iscolourDark?.Colour8,
            border: `2px solid ${isdark === "light"
              ? iscolour?.Colour12
              : iscolourDark?.Colour8
              }`,
          }}
        >
          <FaChartLine size={isMobile ? 16 : 20} />
        </button>

        <button
          onClick={() => setChartType("pie")}
          title="Pie Chart"
          className="hover-scale-btn"
          style={{
            width: isMobile ? "30px" : "40px",
            height: isMobile ? "30px" : "40px",
            borderRadius: "12px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "0.3s",
            backgroundColor:
              chartType === "pie"
                ? isdark === "light"
                  ? iscolour?.Colour12
                  : iscolourDark?.Colour8
                : "transparent",
            color:
              chartType === "pie"
                ? isdark === "light"
                  ? iscolour?.Colour1
                  : "#fff"
                : isdark === "light"
                  ? iscolour?.Colour12
                  : iscolourDark?.Colour8,
            border: `2px solid ${isdark === "light"
              ? iscolour?.Colour12
              : iscolourDark?.Colour8
              }`,
          }}
        >
          <FaChartPie size={isMobile ? 16 : 20} />
        </button>
      </div>

      {/* CHART */}
      <div
        style={{
          marginTop: "10px",
          width: "100%",
          height: isMobile ? "300px" : "400px",
        }}
      >
        {!hasChartData ? (
          <div
            style={{
              position: "relative",
              width: "100%",
              height: "100%",
              minHeight: "300px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
              borderRadius: "20px",
              background:
                isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour7,
              padding: "20px",
            }}
          >
            <div
              style={{
                position: "absolute",
                width: "220px",
                height: "220px",
                borderRadius: "50%",
                background:
                  isdark === "light"
                    ? "rgba(0,0,0,0.03)"
                    : "rgba(255,255,255,0.03)",
                top: "-70px",
                right: "-70px",
              }}
            />

            <div
              style={{
                position: "absolute",
                width: "160px",
                height: "160px",
                borderRadius: "50%",
                background:
                  isdark === "light"
                    ? "rgba(0,0,0,0.03)"
                    : "rgba(255,255,255,0.03)",
                bottom: "-50px",
                left: "-50px",
              }}
            />

            <div
              style={{
                position: "relative",
                width: "100%",
                maxWidth: "450px",
                padding: "35px 25px",
                borderRadius: "24px",
                textAlign: "center",
                background:
                  isdark === "light"
                    ? "rgba(255,255,255,0.75)"
                    : "rgba(35,38,47,0.75)",
                backdropFilter: "blur(10px)",
                boxShadow:
                  isdark === "light"
                    ? "0 10px 35px rgba(0,0,0,0.08)"
                    : "0 10px 35px rgba(0,0,0,0.35)",
                border:
                  isdark === "light"
                    ? "1px solid rgba(255,255,255,0.7)"
                    : "1px solid rgba(255,255,255,0.08)",
              }}
            >
              <div
                style={{
                  width: "90px",
                  height: "90px",
                  borderRadius: "50%",
                  margin: "0 auto 20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background:
                    isdark === "light"
                      ? "linear-gradient(135deg,#f3f7ff,#dce8ff)"
                      : "linear-gradient(135deg,#2d3342,#1f2430)",
                }}
              >
                <FaChartPie
                  size={40}
                  color={
                    isdark === "light"
                      ? iscolour?.Colour12
                      : iscolourDark?.Colour10
                  }
                />
              </div>

              <h3
                style={{
                  fontWeight: "700",
                  fontSize: "26px",
                  marginBottom: "10px",
                  color:
                    isdark === "light"
                      ? iscolour?.Colour12
                      : iscolourDark?.Colour10,
                }}
              >
                No Chart Data Available
              </h3>

              <p
                style={{
                  margin: 0,
                  fontSize: "15px",
                  lineHeight: "24px",
                  color:
                    isdark === "light"
                      ? "rgba(0,0,0,0.6)"
                      : "rgba(255,255,255,0.6)",
                }}
              >
                There is currently no data available to display
              </p>
            </div>
          </div>
        ) : (
          <ReactECharts
            key={chartType}
            option={getOption()}
            notMerge={true}
            lazyUpdate={true}
            autoResize={true}
            opts={{
              renderer: "canvas",
            }}
            style={{
              width: "100%",
              height: "100%",
            }}
          />
        )}
      </div>
    </div>
  );
};

export default FASChart;
